import React from "react";
import { useSearchParams } from "react-router-dom";
import AlbumList from "./AlbumList";
import ArtistList from "./ArtistList";
import TrackList from "./TrackList";

function BrowsePage({
  onSelect,
  onArtistSelect,
  start,
  collectionRevision,
  showImportPrompt = false,
  onImport,
  importStatus,
  startingImport,
  onCancelImport,
}) {
  const [params, setParams] = useSearchParams();
  const requestedView = params.get("view");
  const view = ["album", "artist", "track"].includes(requestedView)
    ? requestedView
    : "album";
  const setView = React.useCallback(
    (v) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (v && v !== "album") next.set("view", v);
          else next.delete("view");
          return next;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  const handleTrackSelect = (track) => {
    const albumId = track.album?.id ?? track.album ?? track.album_id;
    if (albumId) {
      onSelect && onSelect(albumId, track.id);
    }
  };

  return (
    <div>
      {view === "album" && (
        <AlbumList
          refreshRevision={collectionRevision}
          onSelect={onSelect}
          onArtistSelect={onArtistSelect}
          start={start}
          showImportPrompt={showImportPrompt}
          onImport={onImport}
          importStatus={importStatus}
          startingImport={startingImport}
          onCancelImport={onCancelImport}
          view={view}
          onViewChange={setView}
        />
      )}
      {view === "artist" && (
        <ArtistList
          refreshRevision={collectionRevision}
          onSelect={(id) => onArtistSelect && onArtistSelect(id)}
          view={view}
          onViewChange={setView}
        />
      )}
      {view === "track" && (
        <TrackList
          refreshRevision={collectionRevision}
          onSelect={handleTrackSelect}
          view={view}
          onViewChange={setView}
        />
      )}
    </div>
  );
}

export default BrowsePage;
